<template lang="html">
  <div>
    <h2 :class="$style.title">Нам доверяют {{ totalClients }}+ компаний</h2>
    <div :class="[$style.block, $style[`clients-${clientsInGroup}`]]">
      <div ref="group" v-for="(group, index) in logos" :key="index" :class="$style.group">
        <div ref="logo" v-for="(client, index) in group" :key="index" :class="$style.item">
          <img :src="client" :class="$style.logo" alt="Логотип" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import chunk from 'lodash/chunk';

import { BREAKPOINTS } from '~scripts/core/breakpoints';

export default {
  name: 'CasesLogo',
  props: {
    filteredIndustries: {
      type: Array,
      default: [],
    },
    industries: {
      type: Array,
      default: [],
    },
    totalClients: {
      type: Number,
      default: 0,
    },
  },
  data() {
    const mediaQuery = {
      md: window.matchMedia(`(min-width: ${BREAKPOINTS.mdMin})`),
      xl: window.matchMedia(`(min-width: ${BREAKPOINTS.xlMin})`),
    };
    return {
      mediaQuery: mediaQuery,
      groups: this.getCount(mediaQuery),
    };
  },
  computed: {
    clientsInGroup() {
      return this.filteredIndustries.length ? this.filteredIndustries.length : this.industries.length;
    },
    logos() {
      const category = this.industries.map((item) => item.id);
      const logoPaths = [];

      for (let i = 0; i < 5; i++) {
        const categories = this.filteredIndustries.length ? this.filteredIndustries.map((item) => item.id) : category;
        for (const cat of categories) {
          logoPaths.push(`static/promo-static/landing-2021/src/images/pages/cases/index/logos/${cat}/${i}.svg`);
        }
      }

      return chunk(logoPaths, this.clientsInGroup).slice(0, this.groups);
    },
  },
  created() {
    this.mediaQuery.md.addEventListener('change', this.handleMediaMatch);
    this.mediaQuery.xl.addEventListener('change', this.handleMediaMatch);
  },
  methods: {
    getCount(mediaQuery) {
      return mediaQuery.md.matches ? (this.groups = 5) : (this.groups = 3);
    },
    handleMediaMatch() {
      this.groups = this.getCount(this.mediaQuery);
    },
  },
};
</script>

<style module lang="scss">
@use '~styles/core/_variables.scss' as vars;
@use '~styles/core/_mixins.scss' as mixins;

.title {
  @include mixins.font(1.6rem, 1.5);

  margin-bottom: 0.6rem;
  color: #999;
  font-weight: vars.$fontWeightBase;
  letter-spacing: initial;
  text-align: center;

  @include mixins.media(md) {
    @include mixins.font(2.2rem, 1.25);
  }
}

@mixin fadeIn($duration, $delay, $name) {
  animation: {
    delay: $delay;
    duration: $duration;
    fill-mode: both;
    iteration-count: infinite;
    name: $name;
  }

  transition-timing-function: ease-in;
  will-change: opacity;
}

@mixin animationInit($groupNum, $clientNum, $fadeInDuration, $fadeInDelay, $fadeInTiming) {
  @for $group from 1 through $groupNum {
    @for $client from 1 through $clientNum {
      .group:nth-child(#{$group}) .item:nth-child(#{$client}) {
        @include fadeIn(
          $fadeInDuration,
          calc(#{$fadeInDelay} * (#{$client} - 1) + 0.3s * (#{$group} - 1)),
          $fadeInTiming
        );
      }
    }
  }
}

.block {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  padding-bottom: 1rem;

  @include mixins.media(md) {
    flex-wrap: nowrap;
    padding-bottom: 1.6rem;
  }

  @include mixins.media(lg) {
    padding-bottom: 2rem;
  }
}

.clients-2 {
  @keyframes fadeIn2 {
    0% {
      opacity: 0;
    }

    20% {
      opacity: 1;
    }

    40% {
      opacity: 1;
    }

    60% {
      opacity: 0;
    }

    100% {
      opacity: 0;
    }
  }
  @include animationInit(3, 2, 10s, 5s, fadeIn2);

  @include mixins.media(md) {
    @include animationInit(5, 2, 14s, 7s, fadeIn2);
  }
}

.clients-3 {
  @keyframes fadeIn3 {
    0% {
      opacity: 0;
    }

    12.5% {
      opacity: 1;
    }

    25% {
      opacity: 1;
    }

    37.5% {
      opacity: 0;
    }

    100% {
      opacity: 0;
    }
  }
  @include animationInit(3, 3, 15s, 5s, fadeIn3);

  @include mixins.media(md) {
    @include animationInit(5, 3, 21s, 7s, fadeIn3);
  }
}

.clients-4 {
  @keyframes fadeIn4 {
    0% {
      opacity: 0;
    }

    10% {
      opacity: 1;
    }

    20% {
      opacity: 1;
    }

    30% {
      opacity: 0;
    }

    100% {
      opacity: 0;
    }
  }
  @include animationInit(3, 4, 20s, 5s, fadeIn4);

  @include mixins.media(md) {
    @include animationInit(5, 4, 28s, 7s, fadeIn4);
  }
}

.clients-5 {
  @keyframes fadeIn5 {
    0% {
      opacity: 0;
    }

    7.5% {
      opacity: 1;
    }

    15% {
      opacity: 1;
    }

    22.5% {
      opacity: 0;
    }

    100% {
      opacity: 0;
    }
  }
  @include animationInit(3, 5, 25s, 5s, fadeIn4);

  @include mixins.media(md) {
    @include animationInit(5, 5, 35s, 7s, fadeIn5);
  }
}

.clients-6 {
  @keyframes fadeIn6 {
    0% {
      opacity: 0;
    }

    5% {
      opacity: 1;
    }

    10% {
      opacity: 1;
    }

    20% {
      opacity: 0;
    }

    100% {
      opacity: 0;
    }
  }

  @include animationInit(3, 6, 30s, 5s, fadeIn6);

  @include mixins.media(md) {
    @include animationInit(5, 6, 42s, 7s, fadeIn6);
  }
}

.clients-7 {
  @keyframes fadeIn7 {
    0% {
      opacity: 0;
    }

    5% {
      opacity: 1;
    }

    10% {
      opacity: 1;
    }

    20% {
      opacity: 0;
    }

    100% {
      opacity: 0;
    }
  }

  @include animationInit(3, 7, 35s, 5s, fadeIn7);

  @include mixins.media(md) {
    @include animationInit(5, 7, 49s, 7s, fadeIn7);
  }
}

.clients-8 {
  @keyframes fadeIn8 {
    0% {
      opacity: 0;
    }

    4.2% {
      opacity: 1;
    }

    8.4% {
      opacity: 1;
    }

    16.8% {
      opacity: 0;
    }

    100% {
      opacity: 0;
    }
  }

  @include animationInit(3, 8, 40s, 5s, fadeIn8);

  @include mixins.media(md) {
    @include animationInit(5, 8, 56s, 7s, fadeIn8);
  }
}

.clients-9 {
  @keyframes fadeIn9 {
    0% {
      opacity: 0;
    }

    3.8% {
      opacity: 1;
    }

    7.6% {
      opacity: 1;
    }

    15.2% {
      opacity: 0;
    }

    100% {
      opacity: 0;
    }
  }

  @include animationInit(3, 9, 45s, 5s, fadeIn9);

  @include mixins.media(md) {
    @include animationInit(5, 9, 63s, 7s, fadeIn9);
  }
}

.group {
  position: relative;
  display: inline-flex;

  @include mixins.media(md) {
    flex: 1 0 0;
  }
}

.item {
  display: inline-flex;
  width: 100%;
  pointer-events: none;

  &:not(:first-child) {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }
}

.logo {
  @include mixins.size(100px, 51px);

  filter: opacity(0.5);

  @include mixins.media(md) {
    @include mixins.size(100%, auto);

    max-width: 200px;
  }
}
</style>
